<!-- 1440 安全  -->
<template>
  <section class="header_view">
    <div class="header">
      <div class="headerBox">
        <div class="boxLeft">
          <ul>
            <li>
              <img :src="require('@/assets/image/icon/logo2.png')" alt="" />
            </li>
            <li
              v-for="(item, index) in nav"
              :key="index"
              :class="select == item.id ? 'select' : ''"
              @click="but(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <!-- <div class="boxRight" style="margin-left: 20px">
          <span @click="toAdminRegister()">學校報名</span>
        </div> -->
      </div>
      <div class="header_Right">
        <div class="boxRight">
          <!-- TODO: 0307  -->
          <!-- <span @click="aheftBut()">{{ $t("home.competition_content_and_schedule.registration") }}</span> -->
          <!-- TODO: 0401 -->
          <!-- <span @click="handleUploadVideo()" style="filter: grayscale(0);">{{ $t("achievement.upload_video") }}</span>  -->
        </div>
        <div class="language-selector" @click="lang_popupShow = true">
          <img
            :src="require('@/assets/image/icon_switch_language.png')"
            alt=""
            class="language-icon"
          />
          <div class="lang_text">
            {{ selectedLanguageName }}
            <img
              :src="require('@/assets/image/icon/down.png')"
              alt=""
              class="down-icon"
            />
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="lang_popupShow"
      show-cancel-button
      :title="$t('other_pages.select_language')"
      @confirm="confirmLanguage"
      @cancel="cancelLanguage"
      :confirm-button-text="$t('other_pages.confirm')"
      :cancel-button-text="$t('other_pages.cancel')"
    >
      <van-radio-group
        v-model="selectedLanguage"
        direction="vertical"
        class="radio-group"
      >
        <van-radio
          v-for="(language, index) in languages"
          :key="index"
          :name="language.code"
          class="radio-item"
        >
          {{ language.name }}
        </van-radio>
      </van-radio-group>
    </van-dialog>
  </section>
</template>

<script>
export default {
  name: "views",
  data() {
    return {
      nav: [
        {
          id: "0",
          name: this.$t('other_pages.home_page'),
          path: "/",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        // 	id:1,
        // 	name:'比賽指引',
        // 	path:'/',
        //   href:null,
        // },
        {
          id: "2",
          name: this.$t('other_pages.competition_materials'),
          path: "/material",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        //   id: "2",
        //   name: this.$t('other_pages.competition_materials'),
        //   path: "/",
        //   href: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/15b7103e9d1c71e09264611df669ff29.pdf",
        //   type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        // },
        {
          id: "3",
          name: this.$t('other_pages.results_announcement'),
          path: "/achievement",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        //   id: "4",
        //   name: "比赛章程",
        //   path: "/constitution",
        //   href: null,
        //   type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        // },
        {
          id: "4",
          name: this.$t('other_pages.competition_rules'),
          path: "/",
          href: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/competition_regulations.pdf",
          type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        {
          id: "5",
          name: this.$t('other_pages.app_download'),
          path: "/",
          href: "https://school.chineserd.com/#/download-student",
          type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
      ],
      lang_popupShow: false,
      languages: [
        {
          name: "简体中文",
          code: "zh_CN",
        },
        {
          name: "Bahasa Indonesia",
          code: "id_ID",
        },
      ],
      selectedLanguage: this.$i18n.locale,
      previousLanguage: this.$i18n.locale, // 用于取消时恢复之前的语言
    };
  },
  props: {
    select: {
      type: String,
      default: "0",
    },
  },
  computed: {
    selectedLanguageName() {
      const selected = this.languages.find(
        (lang) => lang.code === this.selectedLanguage
      );
      return selected ? selected.name : "";
    },
  },
  components: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    confirmLanguage() {
      this.$i18n.locale = this.selectedLanguage;
      // 刷新页面
      location.reload();
      // this.lang_popupShow = false;
      localStorage.setItem("i18n", this.selectedLanguage);
    },
    cancelLanguage() {
      this.selectedLanguage = this.previousLanguage;
      this.lang_popupShow = false;
    },
    getQueryString: function (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    toAdminRegister() {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '報名未開始',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })
      //   return
      // 跳管理后台注册页
      var url = "https://edu.chineserd.com/user/register?redirect=true";
      window.open(url, "_blank");
    },
    // 上传视频
    handleUploadVideo() {
      // TODO: 0328
      // this.$dialog
      // .alert({
      //   title: '',
      //   message: this.$t('achievement.semi_ended'),
      //   confirmButtonText: this.$t('other_pages.confirm')
      // })
      // .then(() => {
      //   // on close
      // })
      // return;
      if (this.$route.path === '/') {
        this.$emit('viewUploadVideo')
      } else {
        this.$router.push({
          path: '/',
          query: {
            uploadVideo: true
          }
        })
      }
    },
    aheftBut(e) {
      // TODO: 0307
      // this.$dialog
      // .alert({
      //   title: '',
      //   message: this.$t('achievement.has_ended'),
      //   confirmButtonText: this.$t('other_pages.confirm')
      // })
      // .then(() => {
      //   // on close
      // })
      // return;
      if (
        this.getQueryString("c") != null ||
        this.getQueryString("c") != undefined
      ) {
        this.$router.push("/signup?c=" + this.getQueryString("c"));
      } else {
        this.$router.push("/signup");
      }
    },
    heftBut(e) {
      this.$router.push(e);
    },
    but(e) {
      if (e.id == this.select) {
        console.log("不生效");
        this.lang_popupShow = false;
      } else {
        console.log(e);

        switch (e.type) {
          case 1:
            this.$router.push(e.path);
            break;
          case 2:
            let baseurl =
              "http://chineserd.cn/h5/html/regulations/index.html?url=" +
              e.href;
            window.open(baseurl, "_blank");
            break;
          case 3:
            window.open(e.href, "_blank");
            break;
          default:
            break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header_view {
  width: 100%;
  height: 80px;
  position: relative;
  .header {
    position: sticky;
    width: 100%;
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s;
    position: fixed;
    z-index: 2000;
    background: #ff891f;
    box-shadow: 0px 4px 20px 0px rgba(164, 79, 0, 0.15);

    .headerBox {
      max-width: 1246px;
      height: 80px;
      margin: auto;
      display: flex;
      justify-content: space-between;

      .boxLeft {
        height: 100%;
        line-height: 1.2;
        ul {
          height: 100%;
          display: flex;

          li {
            width: 160px;
            height: 100%;
            font-size: 20px;
            font-family: PingFang SC-Semibold, PingFang SC;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
              width: 80px;
            }
          }

          .select {
            font-weight: bold;
            background: url("~@/assets/image/hodgepodge/tabBut.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}

.header_Right {
  height: 100%;
  min-width: 360px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .boxRight {
    height: 100%;
    display: flex;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
    // position: relative;
    // left: 0px;
    span {
      min-width: 136px;
      background: url("~@/assets/image/icon/but.png") no-repeat;
      background-size: 100% 100%;
      // background: #d0d0d0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 15px;
      // box-shadow: 0px 4px 9px 0px rgba(244, 86, 5, 0.4);
      box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
      border-radius: 80px;
      padding: 20px 15px;
      box-sizing: border-box;
    }
  }
  .language-selector {
    display: flex;
    align-items: center;
    margin-right: 10px;
    text-align: left;
    cursor: pointer;
    .language-icon {
      margin-right: 6px;
      width: 20px;
    }
    .down-icon {
      margin: 0 5px;
      width: 15px;
    }
    .lang_text {
      font-size: 16px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 15px;
      margin-right: 6px;
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
  }
}
.van-dialog {
  width: 400px;
  .radio-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    margin: 25px 50px;
  }
  .radio-item {
    margin-bottom: 22px;
  }
}
</style>
